// Sending the buyer to the shop. Ducks always go into the customer's own Shopify cart on the store (it accumulates
// across visits, and the store's cart page shows each duck's own picture); the server picks the link (see basket_api).
import { toast } from "sonner";

// Navigate the TOP window (the app can run embedded in the shop or a preview frame). If we are still here a moment
// later the jump was blocked, so offer the link in a new tab instead of leaving the buyer stuck.
export function openShop(url) {
  const a = document.createElement("a");
  a.href = url;
  a.target = "_top";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  const timer = setTimeout(() => {
    if (!document.hidden) {
      toast("The shop didn't open?", {
        description: "Your browser blocked the jump to the shop.",
        action: { label: "Open the cart", onClick: () => window.open(url, "_blank", "noopener") },
        duration: 12000,
      });
    }
  }, 2500);
  window.addEventListener("pagehide", () => clearTimeout(timer), { once: true });
}
